<div class="hidden-sm mt-64">
  <div class="typography typography-h3 typography-paragraph black">
    Поиск по материалам
  </div>

  <div class="grid grid-gutter-72">
    <div class="grid grid-item grid-6 grid-sm-12">
      <ng-container *ngTemplateOutlet="searchInputContent"></ng-container>

      <button
        class="button button-primary ml-12"
        [disabled]="!(contentQuery$ | async)"
        (click)="searchByContent()"
      >
        Найти
      </button>
    </div>

    <div class="grid-item grid-6 grid-sm-12 grid">
      <ng-container *ngTemplateOutlet="searchInputPublisher"></ng-container>

      <button
        class="button button-primary ml-12"
        [disabled]="!(publisherNameQuery$ | async)"
        (click)="searchByPublisher()"
      >
        Найти
      </button>
    </div>
  </div>
</div>

<div class="hidden block-sm mb-40">
  <div class="typography typography-h4 typography-paragraph black">
    Поиск по материалам
  </div>
  <div class="full-width grid">
    <ng-container *ngTemplateOutlet="searchInputContent"></ng-container>

    <button
      class="button button-primary ml-12"
      [disabled]="!(contentQuery$ | async)"
      (click)="searchMobileByContent()"
    >
      Найти
    </button>
  </div>

  <div class="full-width grid mt-20">
    <ng-container *ngTemplateOutlet="searchInputPublisher"></ng-container>

    <button
      class="button button-primary ml-12"
      [disabled]="!(publisherNameQuery$ | async)"
      (click)="searchMobileByPublisher()"
    >
      Найти
    </button>
  </div>
</div>

<ng-template #searchInputContent>
  <input
    class="search-bar-input input grid-item grid-grow"
    type="search"
    autocomplete="on"
    maxlength="50"
    placeholder="Поиск по тексту"
    [ngModel]="contentQuery$ | async"
    (ngModelChange)="changeValueContent($event)"
  />
</ng-template>

<ng-template #searchInputPublisher>
  <input
    class="search-bar-input input grid-item grid-grow"
    type="search"
    autocomplete="on"
    maxlength="50"
    placeholder="Поиск по изданию"
    [ngModel]="publisherNameQuery$ | async"
    (ngModelChange)="changeValuePublisher($event)"
  />
</ng-template>
